import requests from "./httpService";

const TajaNewsEnquiryService = {
  submitPublic(body) {
    return requests.post("/enquiry/taja-news/public", body);
  },
};

export default TajaNewsEnquiryService;
